import { gql } from "@apollo/client";

/**
 * GraphQL documents for Settings › Roles & Permissions. Re-exported through
 * `~/api`.
 */

export const Role = {
  fragments: {
    RoleData: gql`
      fragment RoleData on Role {
        _id
        name
        description
        type
        systemKey
        permissions
        userCount
      }
    `,
  },
};

export const LIST_OWN_OEM_ROLES_QUERY = gql`
  query listOwnOemRoles {
    listOwnOemRoles {
      ...RoleData
    }
  }
  ${Role.fragments.RoleData}
`;

export const CREATE_OWN_OEM_ROLE_MUTATION = gql`
  mutation createOwnOemRole($input: InputCreateOwnOemRole!) {
    createOwnOemRole(input: $input) {
      ...RoleData
    }
  }
  ${Role.fragments.RoleData}
`;

export const UPDATE_OWN_OEM_ROLE_MUTATION = gql`
  mutation updateOwnOemRole($input: InputUpdateOwnOemRole!) {
    updateOwnOemRole(input: $input) {
      ...RoleData
    }
  }
  ${Role.fragments.RoleData}
`;

export const DUPLICATE_OWN_OEM_ROLE_MUTATION = gql`
  mutation duplicateOwnOemRole($input: InputDuplicateOwnOemRole!) {
    duplicateOwnOemRole(input: $input) {
      ...RoleData
    }
  }
  ${Role.fragments.RoleData}
`;

export const DELETE_OWN_OEM_ROLE_MUTATION = gql`
  mutation deleteOwnOemRole($input: InputDeleteOwnOemRole!) {
    deleteOwnOemRole(input: $input)
  }
`;
